/**
 * @author tomekbuszewski
 * @since 2019-3-21
 */

import { applyMiddleware, compose, createStore, Middleware } from "redux";
import thunk from "redux-thunk";

import { IS_BROWSER, REDUX_STATE_KEY, IS_DEV } from "@config/consts";

import reducers from "./reducers";

const middleware: Middleware[] = [thunk];
const win = IS_BROWSER ? (window as any) : null;

const initialState = IS_BROWSER ? win[REDUX_STATE_KEY] || {} : {};
const composeEnhancers =
  (IS_DEV && win && win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const makeStore = () => {
  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  return store;
};

export default makeStore();
